export interface CalendarEvent {
  title: string
  start: string // ISO date string
  end: string   // ISO date string
  description?: string
  location?: string
}

/**
 * Format date to Google Calendar format (UTC): YYYYMMDDTHHMMSSZ
 */
function formatGoogleDate(dateStr: string): string {
  return new Date(dateStr).toISOString().replace(/[-:]/g, '').replace(/\.[0-9]{3}/, '')
}

export function downloadIcsFile(event: CalendarEvent): void {
  const start = formatGoogleDate(event.start)
  const end = formatGoogleDate(event.end)
  
  // Escape for ICS
  const escape = (str?: string) => (str || '').replace(/[\\,;]/g, (match) => `\\${match}`).replace(/\n/g, '\\n')
  
  const icsLines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Motionlab//Calendar Event//DE',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `DTSTART:${start}`,
    `DTEND:${end}`,
    `SUMMARY:${escape(event.title)}`,
    `DESCRIPTION:${escape(event.description)}`,
    `LOCATION:${escape(event.location)}`,
    'STATUS:CONFIRMED',
    'SEQUENCE:0',
    'BEGIN:VALARM',
    'TRIGGER:-PT15M',
    'ACTION:DISPLAY',
    'DESCRIPTION:Reminder',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR'
  ]

  const blob = new Blob([icsLines.join('\r\n')], { type: 'text/calendar;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${event.title.replace(/\s+/g, '_')}.ics`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
